import React from "react";
import styled from "styled-components";

interface IProps {
	width?: number;
	height?: number;
	color?: string;
	onClick?: () => void;
}

const SVG = styled.svg``;

export const IconDoubtful: React.FC<IProps> = ({color, ...rest}) => (
	<SVG viewBox="0 0 16 14" fill="none" {...rest}>
		<path
			pointerEvents="none"
			d="M1.57544 12.6879L8.00001 1.44495L14.4246 12.6879H1.57544Z"
			fill="#FFDF02"
			stroke="#222222"
		/>
		<path
			pointerEvents="none"
			d="M8.9001 10.4378L8.0001 11.3378L7.1001 10.4378L8.0001 9.53784L8.9001 10.4378Z"
			fill="#222222"
		/>
		<rect
			pointerEvents="none"
			x="8.44995"
			y="8.63794"
			width="0.9"
			height="3.6"
			transform="rotate(-180 8.44995 8.63794)"
			fill="#222222"
		/>
	</SVG>
);

IconDoubtful.defaultProps = {
	width: 16,
	height: 14,
	color: "currentColor",
};
